import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  // ── Public / guest-only pages ────────────────────────────────────────────
  // Already logged in → redirect to /dashboard
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login/login').then((m) => m.LoginPage),
  },
  {
    path: 'login/password-forgotten',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./pages/login/password-forgotten/password-forgotten').then(
        (m) => m.PasswordForgottenPage,
      ),
  },
  {
    path: 'login/reset-password',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./pages/login/reset-password/reset-password').then((m) => m.ResetPasswordPage),
  },
  // ── App shell (sidebar + header) — requires active session ──────────────
  {
    path: '',
    canActivate: [authGuard],
    // Re-run guards on every child navigation so the MFA-enforcement redirect
    // in authGuard fires even when navigating between sibling child routes.
    runGuardsAndResolvers: 'always',
    loadComponent: () =>
      import('./layouts/dashboard-layout/dashboard-layout').then((m) => m.DashboardLayout),
    children: [
      // Redirect bare root URL to dashboard
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.DashboardPage),
      },
      {
        path: 'account',
        loadComponent: () => import('./pages/account/account').then((m) => m.AccountPage),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications/notifications').then((m) => m.NotificationsPage),
      },
      {
        path: 'security',
        loadComponent: () => import('./pages/security/security').then((m) => m.SecurityPage),
      },
      {
        path: 'backups',
        loadComponent: () => import('./pages/backups/backups').then((m) => m.BackupsPage),
      },
      {
        path: 'backups/:id',
        loadComponent: () =>
          import('./pages/backup-detail/backup-detail').then((m) => m.BackupDetailPage),
      },
      {
        path: 'documents',
        loadComponent: () => import('./pages/contracts/contracts').then((m) => m.ContractsPage),
      },
      {
        path: 'activity-log',
        loadComponent: () =>
          import('./pages/activity-log/activity-log').then((m) => m.ActivityLogPage),
      },
      {
        path: 'company',
        loadComponent: () => import('./pages/company/company').then((m) => m.CompanyPage),
      },
      {
        path: 'infrastructure',
        loadComponent: () =>
          import('./pages/infrastructure/infrastructure').then((m) => m.InfrastructurePage),
      },
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadComponent: () => import('./pages/admin/admin').then((m) => m.AdminPage),
      },
      {
        path: 'admin/tenants/:id',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./pages/admin/tenant-detail/tenant-detail').then((m) => m.TenantDetailPage),
      },
      {
        path: 'admin/tenants/:id/runs/:runId',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./pages/admin/run-detail/run-detail').then((m) => m.RunDetailPage),
      },
      {
        path: 'admin/tenants/:id/jobs/:jobId',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./pages/admin/job-detail/job-detail').then((m) => m.JobDetailPage),
      },
      {
        path: 'admin/users/:id',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./pages/admin/user-detail/user-detail').then((m) => m.AdminUserDetailPage),
      },
    ],
  },

  // ── Fallback ─────────────────────────────────────────────────────────────
  { path: '**', redirectTo: 'login' },
];
